import axios from './HttpRequestAccount';
import User from './HttpRequestCustomerApp';
import loyalty from "./HttpRequestLoyalty";


 function ckeckStatus(params){
        return axios.post('/v2/account/status', params);
    }

    function sendOTP(params){
        return axios.post('/v2/otp/send',params)
    }

    function verifyOTP(params){
        return axios.post('/v2/otp/verify',params)
    }

    function getInfo(token){
       return User.get('/web/user/info', { headers: {'Authorization': "Bearer "+token}});
    }

    function getNoti(page,status, token){
        //  return User.get('/web/notification/all?page='+page+'&per_page=10&channel=0',{ headers: {'Authorization': "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMTc2MDI0NSwiaWF0IjoxNjk3NDI2Nzg4LCJleHAiOjE3MDYwNjY3ODh9.N7-s6RVNARxKACuVnvozTro1FKyJlzrO6bkpsrk0SZE"}});
        if(status >= 0){
            return User.get('/web/notification/all?page='+page+'&per_page=20&channel='+status,{ headers: {'Authorization': "Bearer "+token}});
        }
        if(status < 0){
            return User.get('/web/notification/all?page='+page+'&per_page=20',{ headers: {'Authorization': "Bearer "+token}});
        }
       
    }
    function getNotiDetail(id, token){
        //  return User.get('/web/notification/detail/'+id,{ headers: {'Authorization': "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMTc2MDI0NSwiaWF0IjoxNjk3NDI2Nzg4LCJleHAiOjE3MDYwNjY3ODh9.N7-s6RVNARxKACuVnvozTro1FKyJlzrO6bkpsrk0SZE"}});
        return User.get('/web/notification/detail/'+id,{ headers: {'Authorization': "Bearer "+token}});
    }

    function updateInfo(params, token){
        return User.post('/user/update', params, { headers: {'Authorization': "Bearer "+token}})
    }
    /**
     * {
        "_id": "6517a0e3e57c4978bb436ce5",
        "address": "C13 khu đấu giá",
        "created": "2023-09-30T11:15:31.005",
        "updated": "2023-09-30T11:15:31.005",
        "current": false,
        "province": {
            "_id": 26,
            "code": "HNO",
            "macroregion": 1,
            "type": "Thành phố TW",
            "name": "Hà Nội"
        },
        "district": {
            "_id": 189,
            "code": "QH268",
            "macroregion": 1,
            "name": "Quận Hà Đông",
            "province": 26,
            "region": 3
        },
        "ward": {
            "_id": 4086,
            "code": "PX09544",
            "district": 189,
            "macroregion": 1,
            "name": "Phường Vạn Phúc",
            "province": 26,
            "region": 3
        },
        "location": {
            "latitude": 20.962048,
            "longitude": 105.7827439
        },
        "name": "Lê Trọng Nghĩa",
        "phone": "0982022028",
        "type_address": 1
    }
     * @param {*} params 
     * @param {*} token 
     * @returns 
     */
    function updateAddress(params, token){
        return User.post('/web/user/address/update', params, { headers: {'Authorization': "Bearer "+token}})
    }
    /**
     * {
            "_id": "651f86882a259751b4e95bf5"
        }
     */
        function deleteAddress(params, token){
        return User.post('/web/user/address/delete', params, { headers: {'Authorization': "Bearer "+token}})
    }
    function getAddress(token){
        return User.get('/web/user/address', { headers: {'Authorization': "Bearer "+token}})
    }

    function getOrder(page, status, token){
        let _status = '';
        if(status != null){
            _status='&status='+status;
        }
        return User.get('/web/order/filter/all?page='+page+'&per_page=10'+_status,  { headers: {'Authorization': "Bearer "+token}})
    }
    function getOrderFull(page, status, token){
        let _status = '';
        if(status != null){
            _status='&status='+status;
        }
        return User.get('/web/order/filter/all?page='+page+'&per_page=10'+_status,  { headers: {'Authorization': "Bearer "+token}})
    }

    function getOrderDetail(id, token){
        return User.get('/web/order/detail/'+id,  { headers: {'Authorization': "Bearer "+token}});
    }

    function orderCancel(params, token){
        return User.post('/web/order/cancel', params, { headers: {'Authorization': "Bearer "+token}});
    }
    function postReferral(params, token){
        return User.post('/web/user/referral', params, { headers: {'Authorization': "Bearer "+token}});
    }   

    function  getInfoClass(token){
        return loyalty.get('/v3/customer', { headers: {'Authorization': "Bearer "+token}});
    }
    
export  {
    ckeckStatus,
    sendOTP,
    verifyOTP,
    getInfo,
    getNoti,
    getNotiDetail,
    updateAddress,
    getAddress,
    getOrder,
    deleteAddress,
    getOrderDetail,
    orderCancel,
    postReferral,
    getInfoClass,
    getOrderFull,
    updateInfo
}